"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _tokensStylex = require("web/shared/tokens.stylex.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const styles = exports.styles = {
  scroll: {
    width: "xh8yej3",
    overflowX: "xw2csxc",
    $$css: true
  },
  table: {
    width: "xh8yej3",
    borderCollapse: "x1mwwwfo",
    fontFamily: "x1wl88yq",
    fontSize: "x1q2zfhj",
    color: "x10kmngs",
    $$css: true
  },
  headerCell: {
    textAlign: "xdpxx8g",
    backgroundColor: "x1498qn9",
    color: "xcdm7ny",
    fontSize: "x9bimuu",
    fontWeight: "x1s688f",
    textTransform: "xtvhhri",
    letterSpacing: "x1vyo3qp",
    whiteSpace: "xuxw1ft",
    paddingTop: "x181mwm9",
    paddingBottom: "xvfl3op",
    paddingLeft: "x4gs2og",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    paddingRight: "xbygrs",
    borderBottomWidth: "xso031l",
    borderBottomStyle: "x1q0q8m5",
    borderBottomColor: "x196gm1a",
    $$css: true
  },
  headerCellRight: {
    textAlign: "x1hr2gdg",
    $$css: true
  },
  headerCellCenter: {
    textAlign: "x2b8uid",
    $$css: true
  },
  rowClickable: {
    cursor: "x1ypdohk",
    backgroundColor: "xjbqb8w x14sfa1n",
    $$css: true
  },
  cell: {
    textAlign: "xdpxx8g",
    verticalAlign: "x16dsc37",
    paddingTop: "x181mwm9",
    paddingBottom: "xvfl3op",
    paddingLeft: "x4gs2og",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    paddingRight: "xbygrs",
    borderBottomWidth: "xso031l",
    borderBottomStyle: "x1q0q8m5",
    borderBottomColor: "x196gm1a",
    $$css: true
  },
  empty: {
    textAlign: "x2b8uid",
    color: "xcdm7ny",
    fontFamily: "x1wl88yq",
    fontSize: "x1q2zfhj",
    paddingTop: "xg6i1gr",
    paddingBottom: "xbjsyr9",
    paddingLeft: "x13zw8i9",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    paddingRight: "x1f69zfp",
    $$css: true
  }
};